import { render, staticRenderFns } from "./LeadsListItem.vue?vue&type=template&id=5e414df6&scoped=true&"
import script from "./LeadsListItem.vue?vue&type=script&lang=js&"
export * from "./LeadsListItem.vue?vue&type=script&lang=js&"
import style0 from "./LeadsListItem.vue?vue&type=style&index=0&id=5e414df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e414df6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VContainer,VListItem,VRow})
